module.exports = __webpack_public_path__ + "static/media/terraspeak-3.561a0e57.jpg";